import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=357655da&"
import script from "./NotificationsList.vue?vue&type=script&lang=js&"
export * from "./NotificationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports